import { Component, HostListener, Input, OnInit } from '@angular/core';
import { Scorecard, ScorecardDisplayType, ScorecardQuery, ScorecardService } from '@fgb/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { firstValueFrom, Observable } from 'rxjs';
import { OwlCarouselSettings } from '@fgb/portal-component-library/src/lib/shared/utilities';

@Component({
  selector: 'fgbcl-scorecard-carousel',
  templateUrl: './scorecard-carousel.component.html',
  styleUrls: ['./scorecard-carousel.component.scss'],
})
export class ScorecardCarouselComponent implements OnInit {
  scorecard$: Observable<Scorecard[]>;
  @Input() scorecards: Scorecard[];
  @Input() title: string;
  @Input() badgeDescription: string;
  isDragging: boolean = false;
  scorecardDisplayType = ScorecardDisplayType;
  @Input() showAllView: boolean;
  @Input() icon: string = 'info';
  @Input() confettiColors: string[];
  @Input() showPlaceholder: boolean = false;
  @Input() link: string = '/challenges';
  isOpenModal: boolean = true;
  @Input() isSponsorInBody: boolean = false;
  customOptions: OwlOptions = {
    margin: 8,
    autoWidth: true,
    pullDrag: true,
    autoplay: false,
    autoplayTimeout: OwlCarouselSettings.AutoplayTimeout,
    autoplaySpeed: OwlCarouselSettings.AutoplaySpeed,
    navSpeed: 700,
    nav: false,
    dots: true,
    responsive: { 0: { items: 1 }, 900: { items: 3 } },
  };

  constructor(
    private scorecardQuery: ScorecardQuery,
    private scorecardService: ScorecardService
  ) { }

  @HostListener('window:resize', ['$event.target.screen.width'])
  onWindowResize(event: number) {
    if (event > 991) {
      this.isOpenModal = true;
    } else {
      this.isOpenModal = false;
    }
  }

  ngOnInit() {
    firstValueFrom(this.scorecardService.fetchScorecards());
    this.scorecard$ = this.scorecardQuery.selectAllScorecardSorted();
    this.onWindowResize(window.screen.width);
  }
}
